import { render, staticRenderFns } from "./ConsultaCidadaos.vue?vue&type=template&id=75904eb9&scoped=true"
import script from "./ConsultaCidadaos.vue?vue&type=script&lang=js"
export * from "./ConsultaCidadaos.vue?vue&type=script&lang=js"
import style0 from "./ConsultaCidadaos.vue?vue&type=style&index=0&id=75904eb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75904eb9",
  null
  
)

export default component.exports